<template>
  <component
    :is="component"
    v-if="url"
    v-bind="configs"
    class="cursor-pointer gap-2 rounded-md px-4 py-2 leading-6 text-neutral-900 shadow ring-1 ring-inset ring-primary-700 hover:bg-neutral-100 hover:ring-primary-800 active:shadow active:ring-primary-900 mobile:!text-base"
  >
    <slot />
  </component>
</template>

<script lang="ts" setup>
import NuxtLink from '#app/components/nuxt-link';

interface Props {
  target?: string;
  url?: string;
}

const props = withDefaults(defineProps<Props>(), {
  target: '_self',
  url: '',
});

const { $domain } = useNuxtApp();

const isValidUrl = (link: string) => {
  try {
    new URL(link);
  }
  catch {
    return false;
  }
  return true;
};

const url = computed(() => props.url?.replace($domain.host, ''));
const target = toRef(props, 'target');

const validURL = isValidUrl(url.value);
const component = validURL ? 'a' : NuxtLink;

const configs = validURL ? { href: url.value, target: target.value } : { to: url.value, target: target.value };
</script>
